import { Component, OnInit } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { AuthService } from 'src/app/services/auth/auth.service';
import { OrderForTotalDto, StoreResponseDto, StoreService, StoreTotalDto } from 'src/generated_client';
import * as moment from 'moment';
import { OrdersStatusPipe } from 'src/app/pipes/orders-status.pipe';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shop-home',
  templateUrl: './shop-home.component.html',
  styleUrls: ['./shop-home.component.css']
})

export class ShopHomeComponent implements OnInit {

  public pieChartOptions: ChartOptions = {
    responsive: true,
  };

  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [{
    afterLayout: function (chart: any) {
      chart.legend.legendItems.forEach(
        (label: any) => {
          let value = chart.data.datasets[0].data[label.index];

          label.text += ' ' + value;
          return label;
        }
      )
    }
  }];
  public pieChartColors = [
    {
      backgroundColor: ['#D6F6DD', '#dac4f7', '#f4989c', '#ebd2b4', '#acecf7', '#345995', '#484a47', '#5c6d70', '#6e2594'],
    },
  ];

  storeStart: StoreTotalDto = {};
  store: StoreResponseDto = {};

  totalItems: number = 0;
  lastMonthOrdersQty: number = 0;
  showChart: boolean = false;
  title: string = '';

  ordersList: OrderForTotalDto[] = [];
  filteredOrders: OrderForTotalDto[] = [];

  constructor(
    private storeService: StoreService,
    private authService: AuthService,
    private statusPipe: OrdersStatusPipe,
    private router: Router
  ) {
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
  }

  async ngOnInit() {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.store = this.authService.currentUserStore();

    this.storeService.apiStoreGetStoreStartGet(this.store.cdStore).subscribe(response => {

      this.totalItems = Number(response.nmTotalItemStore);
      this.lastMonthOrdersQty = Number(response.nmTotalOrdersLastMonth);

      if (response.orderList) {

        this.ordersList = response.orderList;
      }
    });

    this.showChart = false;
  }

  refreshData() {
    this.router.navigate(['shop-home']);
  }

  getTodaysOrders() {

    this.clearChart();

    let date = String(moment().format());

    let today = date.slice(0, 10);

    this.filteredOrders = this.ordersList.filter(order => {

      if (order.dtCreatedAt) {

        let result = String(order.dtCreatedAt).includes(today);
        return result
      }

      return false
    });

    this.title = 'hoy'

    this.sortData();
  }

  getYesterdaysOrders() {

    this.clearChart();

    let date = moment().subtract(1, 'days').format();

    let yesterday = date.slice(0, 10);

    this.filteredOrders = this.ordersList.filter(order => {

      if (order.dtCreatedAt) {

        let result = String(order.dtCreatedAt).includes(yesterday);
        return result
      }

      return false
    });

    this.title = 'ayer'

    this.sortData();
  }

  getLastWeekOrders() {

    this.clearChart();

    let from = moment().format();

    let to = moment().subtract(7, 'days').format();

    let firstDay = String(from.slice(0, 10));

    let lastDay = String(to.slice(0, 10));

    this.title = 'últimos 7 días'

    this.filterOrdersByRange(firstDay, lastDay);
   
  }

  getPreviousMonthOrders() {

    this.clearChart();

    let dateFrom = moment().subtract(1, 'months').endOf('month').format();
    let dateTo = moment().subtract(1, 'months').startOf('month').format();

    let lastMonthStart = dateFrom.slice(0, 10);
    let lastMonthEnd = dateTo.slice(0, 10);

    this.title = 'mes pasado'

    this.filterOrdersByRange(lastMonthStart, lastMonthEnd);
  }

  getLastMonthOrders() {

    this.clearChart();

    let dateFrom = moment().format();
    let dateTo = moment().subtract(30, 'days').format();

    let from = dateFrom.slice(0, 10);
    let to = dateTo.slice(0, 10);

    this.title = 'últimos 30 días'

    this.filterOrdersByRange(from, to);
  }

  getThisMonthOrders() {

    this.clearChart();

    let dateFrom = moment().format();
    let dateTo = moment().startOf('month').format();

    let from = dateFrom.slice(0, 10);
    let to = dateTo.slice(0, 10);

    this.title = 'este mes'

    this.filterOrdersByRange(from, to);
  }

  getLastSixMonthsOrders() {
    this.clearChart();

    let dateFrom = moment().format();
    let dateTo = moment().subtract(180, 'days').format();

    let from = dateFrom.slice(0, 10);
    let to = dateTo.slice(0, 10);

    this.title = 'últimos seis meses'

    this.filterOrdersByRange(from, to);
  }

  filterOrdersByRange(from: string, to: string) {

    this.clearChart();

    this.filteredOrders = this.ordersList.filter((item: any) => {

      let orderDate = item.dtCreatedAt.slice(0, 10);

      return (orderDate <= from && orderDate >= to)
    });

    this.sortData();
  }

  clearChart() {
    this.pieChartData = [];
    this.pieChartLabels = [];
  }

  sortData() {

    this.filteredOrders.sort((a, b) => (a.nmStatus! > b.nmStatus!) ? 1 : -1);

    for (var i = 0; i <= 8; i++) {

      let result = this.getOccurrence(this.filteredOrders, i);

      if (result != 0) {

        this.pieChartData.push(result);

        let status = String(this.statusPipe.transform(i));

        this.pieChartLabels.push(status)
      }
    }

    this.showChart = true;
  }

  getOccurrence(array: OrderForTotalDto[], value: number) {
    return array.filter(v => (v.nmStatus === value)).length;
  }
}
